import React, { useEffect, useState } from 'react';
import { AppNavigate, AppOutlet } from '@/navigation';
import { ROUTES } from '@/routes';
import { useAppSelector } from '@/hooks';
import { selectAuth } from '@/auth/store';
import { useLoginKey } from '@/forms/hooks';
import { AuthService, ClaimTypes } from '@/auth';
import { Loader } from '@/ui-kit';

export const UnauthenticatedRoute: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { token, currentKey } = useAppSelector(selectAuth);
  const { key } = useLoginKey();

  const [isAuth, setIsAuth] = useState<boolean | null>(null);

  useEffect(() => {
    if (token !== null && token !== '' && key !== false && key !== null) {
      const tokenClaims = new AuthService().getTokenClaims();

      if (tokenClaims[ClaimTypes.Sid] === key) {
        setIsAuth(true);
      } else {
        new AuthService().logout();
      }
    }
  }, [key, currentKey, token]);

  return key === false ? (
    <Loader />
  ) : isAuth ? (
    <AppNavigate to={ROUTES.dashboard} replace />
  ) : (
    <>{children ?? <AppOutlet />}</>
  );
};
